import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";

export const CampusLibraryDetails = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      <div>
        {/* Start Page Banner */}
        <div className="page-banner-area bg-1">
          <div className="container">
            <div className="page-banner-content">
              <h1>Campus Library </h1>
              <ul>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li className="navspace">
                  <Link to="/campus">Campus</Link>
                </li>
                <li className="navspace">Library </li>
              </ul>
            </div>
          </div>
        </div>
        {/* End Page Banner */}

        {/* <!--Start Academic Details Area--> */}
        <div className="academics-details-area pt-100 pb-70">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="academics-details">
                  <div className="details">
                    <h2>A Hub of Knowledge and Inspiration</h2>
                    <p>
                      The library is a sanctuary for learning and creativity.
                      It’s where knowledge is preserved, and ideas flourish,
                      offering resources to inspire minds of all ages.
                    </p>

                    <div className="details-images">
                      <div className="row">
                        <div className="col-lg-4 col-md-4">
                          <img
                            src="assets/images/campus-detail/library1.webp"
                            alt="Image"
                            width={416}  height={277}
                          />  
                        </div>
                        <div className="col-lg-4 col-md-4">
                          <img
                            src="assets/images/campus-detail/reimg.jpg"
                            alt="Image"
                           width={416}  height={277}
                          />
                        </div>
                        <div className="col-lg-4 col-md-4">
                          <img
                            src="assets/images/campus-detail/library3.webp"
                            alt="Image"
                            width={416}  height={277}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="prepare-exam">
                    <h3>Unlocking the World of Learning at the Library</h3>
                    <p>
                      The library is a gateway to endless knowledge, offering a
                      wide array of books, digital resources, and learning
                      opportunities. It's a space designed to fuel curiosity and
                      foster intellectual growth.
                    </p>
                    <div className="row">
                      <div className="col-lg-6 col-md-6">
                        <div className="exam-card">
                          <h4>Vast Collection of Books and Resources</h4>
                          <p>
                            Our library offers an extensive collection of books,
                            journals, and digital resources, catering to every
                            interest and field of study, ensuring access to
                            valuable information.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="exam-card">
                          <h4>Quiet Study Areas for Focused Learning</h4>
                          <p>
                            Designed for concentration, our study spaces provide
                            a quiet environment for reading, research, and
                            personal study, helping you stay focused and
                            productive.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="exam-card">
                          <h4>Digital Access to Knowledge</h4>
                          <p>
                            Beyond physical books, our library provides access
                            to online databases, e-books, and digital archives,
                            expanding learning opportunities for all members.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="exam-card">
                          <h4>Community Programs and Events</h4>
                          <p>
                            We host various workshops, lectures, and community
                            events to engage and educate the public, fostering a
                            love for learning and encouraging lifelong
                            education.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!--End Academic Details Area--> */}
      </div>
    </>
  );
};
